import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ERPPlatforms from "./pages/ERPPlatforms";
import Industries from "./pages/Industries";
import Solutions from "./pages/Solutions";
import Partnerships from "./pages/Partnerships";
import Resources from "./pages/Resources";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";
import AISolutions from "./pages/AISolutions";
import AIProducts from "./pages/AIProducts";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/erp-platforms" element={<ERPPlatforms />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/partnerships" element={<Partnerships />} />
            <Route path="/ai-solutions" element={<AISolutions />} />
            <Route path="/ai-products" element={<AIProducts />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<BlogDetail />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
